import { RouteStaticConfig } from '@/core/types';
import { msg } from '@lingui/core/macro';

export const subscriptions: RouteStaticConfig = {
  path: '/subscriptions',
  label: msg({ id: 'subscriptions.title', message: 'Subscriptions' }),
  guarded: true,
};
